document.addEventListener('DOMContentLoaded', function() {
  const parents = document.querySelectorAll('.product_dis_in');
  parents.forEach((parent, parentIndex) => {
    console.log(`Parent ${parentIndex + 1}:`, parent);
    const children = Array.from(parent.children);
    const readMoreBtn = parent.querySelector('#pro_read_dis');
    const hasMoreThanTwoChildren = children.length > 2;
    const firstChildText = children[0]?.textContent.trim() || '';
    const isFirstChildLong = firstChildText.length > 50;
    if ((hasMoreThanTwoChildren || isFirstChildLong) && readMoreBtn) {
      readMoreBtn.style.display = 'inline-block';
    }
    if (isFirstChildLong && children.length <= 2) {
      parent.classList.add('moreHeight');
    }
    if (readMoreBtn) {
      readMoreBtn.addEventListener('click', function () {
        parent.classList.toggle('active');
        this.textContent = this.textContent === 'Read More +' ? 'Read Less -' : 'Read More +';
        this.closest('.about_vdimg_col')?.classList.toggle('active');
      });
      console.log(`Read More Button in Parent ${parentIndex + 1}:`, readMoreBtn);
    }
    children.forEach((child, childIndex) => {
      console.log(`Child ${childIndex + 1} in Parent ${parentIndex + 1}:`, child);
    });
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//     var searchTitle = document.querySelector(".search_menu_title");
//     var searchInput = document.querySelector(".search_input-wrp");

//         searchTitle.addEventListener("click", function () {
//             this.style.display = "none";
//             searchInput.style.display = "block";
//         });
// });


// document.addEventListener("DOMContentLoaded", function () {
//     var searchInput = document.querySelector(".search__input");
//     var searchTitle = document.querySelector(".search_menu_title");

//     searchInput.addEventListener("input", function () {
//         if (this.value.trim() !== "") {
//             document.body.classList.add("search-active");
//             searchTitle.style.display = "block";
//         } else {
//             document.body.classList.remove("search-active");
//             searchTitle.style.display = "none";
//         }
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
    var searchInput = document.querySelector(".search__input"); // Correct input field
    var searchTitle = document.querySelector(".search_menu_title");
    var searchWrapper = document.querySelector(".search_input-wrp"); // Separate wrapper element

    searchTitle.addEventListener("click", function () {
        this.style.display = "none";
        searchWrapper.style.display = "block"; // Show the wrapper instead of overwriting input
    });

    searchInput.addEventListener("input", function () {
        if (this.value.trim() !== "") {
            document.body.classList.add("search-active");
        } else {
            searchTitle.style.display = "block";
            searchWrapper.style.display = "none"; 
            document.body.classList.remove("search-active");
        }
    });
});




// document.addEventListener("DOMContentLoaded", function () {
//     var searchInput = document.querySelector(".search__input");
//     var searchTitle = document.querySelector(".search_menu_title");

//     searchInput.addEventListener("input", function () {
//         if (this.value.trim() !== "") {
//             document.body.classList.add("search-active");
//             searchInput.style.display = "block";
//             searchTitle.style.display = "none";
//         } else {
//             document.body.classList.remove("search-active");
//             searchInput.style.display = "none";
//             searchTitle.style.display = "block";
//         }
//     });

//     if (searchInput.value.trim() === "") {
//         searchInput.style.display = "none";
//         searchTitle.style.display = "block";
//     }
//     searchTitle.addEventListener("click", function () {
//         searchInput.style.display = "block";
//         searchTitle.style.display = "none";
//     });
// });



// document.querySelectorAll(".product__additional").forEach(function(element) {
//     element.addEventListener("click", function() {
//         // Add 'active' class to clicked element
//         element.classList.add('active');
        
//         // Find the description inside the clicked element and show it
//         var description = element.querySelector('.product__additional-description');
//         if (description) {
//             description.style.display = "block";
//         }
        
//         // Optionally, remove 'active' class after some time and hide the description
//         setTimeout(function() {
//             element.classList.remove('active');
//             if (description) {
//                 description.style.display = "";
//             }
//         }, 3000); // 3000ms = 3 seconds
//     });
// });


// $(document).ready(function () {  
//     var popupCookie = "popup_closed";
//     var popup = $(".kl-private-reset-css-Xuajs1");
//     function getCookie(name) {
//         var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
//         return match ? match[2] : null;
//     }
//     function setCookie(name, value, days) {
//         var expires = "";
//         if (days) {
//             var date = new Date();
//             date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//             expires = "; expires=" + date.toUTCString();
//         }
//         document.cookie = name + "=" + value + "; path=/" + expires;
//     }
//     setInterval(function(){
//       if (getCookie(popupCookie)) {
//           popup.remove();
//       }
//     }, 1000);  
  
//     setTimeout(function(){
//       $(".klaviyo-close-form").on("click", function () {
//           popup.hide();
//           setCookie(popupCookie, "true", 30);
//       });
//     }, 3000);
// });


$(document).ready(function () {
    var popupCookie = "popup_closed";

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + "; path=/" + expires;
    }

    // Continuously check and remove the popup if cookie is set
    setInterval(function () {
        if (getCookie(popupCookie)) {
            $(".klaviyo-form").closest('[role="dialog"]').remove();
        }
    }, 10);

    // Delegate click handler to document so it works even if .klaviyo-close-form loads later
    $(document).on("click", ".klaviyo-close-form", function () {
        $(this).closest('[role="dialog"]').hide();
        setCookie(popupCookie, "true", 30);
    });
});

